import { Grid, useTheme, useMediaQuery, Box } from "@mui/material";
import { ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CardGrid,
  CardBodyGrid,
  DescriptionTypography,
  ImageBox,
  TitleTypography
} from "./SharedItemCard.styles";
import { CardProps } from "./SharedItemCard.types";
import {
  CardCategories
} from "..";
import { ButtonDigited } from "../../components/Button/Button.variants";
import { useNavbarStore } from "../../stores";
import { TruncatedText } from "../TruncatedText";

export function SharedItemCard({

  coverPublicURL,
  id,
  learningObjectTypology,
  shortDescription,
  title,
  topicTags,
  ...props
}: CardProps) {

  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const{ state:routerState } = useLocation();

  const setNavbarItem = useNavbarStore(state => state.setNavbarItem);

  const handleLable = () => {
    let label = t("activity_go");
    if(learningObjectTypology === "PATH"){
      label = t("root_go");
    }
    if(learningObjectTypology === "COURSE"){
      label = t("course_go");
    }

    return (
      <Box display="flex" alignItems="center" gap="0.25rem" fontSize={ "0.75rem" } fontWeight={ 600 }> 
        { label } <ChevronRight fontSize={ "0.75rem" } width={ "1rem" } /> 
      </Box>
    );
  };

  return (
    <CardGrid container { ...props }>
      <Grid
        width={ isMobile ? "100%" : "172px"  }
        height={ "172px" }
        sx={ {
          borderRadius:1,
          flexShrink: 0
        } }
      >
        <ImageBox
          alt={ title }
          component="img"
          src={ coverPublicURL }
          aria-hidden="true"
        />
      </Grid>
      <CardBodyGrid >

        <TitleTypography variant="h1">
          <TruncatedText text={ title } />
        </TitleTypography>

        { topicTags && topicTags?.length > 0 ?
          <CardCategories categories={ topicTags  }
            sx={ {
              [`${theme.breakpoints.down("sm")}`]:{
                marginTop: "-8px"
              }
            } }/> : null
        }

        <DescriptionTypography>
          <TruncatedText
            text={ shortDescription }
            maxLength={ 60 }
            webkitLineClamp={ 3 }
          />
        </DescriptionTypography>
        <ButtonDigited
          typology="linkState"
          sx={ {
            padding: 0
          } }
          onClick={ ()=> {
            navigate(`/esplora/dettaglio/${id}/${learningObjectTypology}`,{ state:{
              ...routerState,
              isFromCommunity:"/community"
            } });
            setNavbarItem("EXPLORE");
          } }
        >
          { handleLable() }
        </ButtonDigited>

      </CardBodyGrid>

    </CardGrid>
  );
}
